export default {
  desc: 'Enjoying share, talk and discuss with other developers makes me want to be a GDE, so that I can share with others widely, joining in comunnity and also attending conferences. Making podcast and content youtube are my new interests.'
};